// 鼎融
// export const baseUrl = 'http://dingrong.qw1000.cn'
// export const imgurl = 'http://dingrongadmin.qw1000.cn/kaptcha/'
// export const imgUrl2 = 'http://dingrongadmin.qw1000.cn/oss/preview?filePath='
// export const appid = 'wxdce66dc317b94ffc'
// export const appName = '鼎融企服'
// export const appLogo = '/static/logo.jpg'
// export const contactPhone = '15558036088'
// export const contactEmail = '2825276661@qq.com'
// 风乐玛
// export const baseUrl = 'http://fenglema.qw1000.cn'
// export const imgurl = 'http://adminfenglema.qw1000.cn/kaptcha/'
// export const imgUrl2 = 'http://adminfenglema.qw1000.cn/oss/preview?filePath='
// export const appid = 'wx173233755f56cafb'
// export const appName = '风乐玛科技'
// export const appLogo = '/static/logo.png'
// export const contactPhone = '15065479888'
// export const contactEmail = '1587640892@qq.com'
// 湖北希驰
export const baseUrl = 'https://wx.hbxcxxkj.cn'
export const imgurl = 'https://admin.hbxcxxkj.cn/kaptcha/'
export const imgUrl2 = 'https://admin.hbxcxxkj.cn/oss/preview?filePath='
export const appid = 'wx83c237bbe9c5d1f5'
export const appName = '湖北希驰'
export const appLogo = '/static/xichi.jpg'
export const contactPhone = '15065479888'
export const contactEmail = '1587640892@qq.com'
// 公用
export const amapKey = 'ea401fb1d0631e46645f8dde26d7ed47' // 用于定位



// WEBPACK FOOTER //
// ./src/service/config.js